<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: {
    label: {
      type: String,
    },
    chartData: {
      type: Array,
    },
    options: {
      type: Object,
    },
  },
  mounted() {
    const emp_razon_social = this.chartData
      .map((d) => d.emp_razon_social)
      .reverse();
    const count = this.chartData.map((d) => d.count).reverse();
    let colores = [];
    for (let i = 1; i < count.length; i++) {
      colores.push("#" + ((Math.random() * 0xfff * i) << 0).toString(16));
    }

    this.renderChart(
      {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: emp_razon_social,
        datasets: [
          {
            label: this.label,
            backgroundColor: colores,
            data: count,
            borderColor: colores,
            borderWidth: 3,
          },
        ],
      },
      this.options
    );
  },
};
</script>
